import styled from 'styled-components';
import { Button } from '@makemydeal/dr-ui-bricks-components';

// Pill treatment on the blue Showroom nav bar, sized to sit next to the Share control.
export const StyledSendToDeskButton = styled(Button)`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.15);
    color: ${({ theme }) => theme.uiBricks.modalBackgroundColor || '#ffffff'};
    cursor: pointer;

    &:hover {
        text-decoration: none !important;
    }

    &:disabled {
        opacity: 0.6;
    }
`;
